<template>
  <div class="home" ref="containerRef">
    <div class="home-content">
      <div class="home-header">
        <img :src="store.state.images.list_icon" class="list-icon" />
        <div class="header-title-box">
          <span class="header-title">生成电子行程单</span>
          <a
            class="jump-old-title"
            href="https://www.yl969.com/ETicketItinerarySingle/Index?key=NoLoginRequired"
            >前往旧版行程单</a
          >
        </div>
      </div>
      <div class="home-content-itinerary">
        <div class="filter-condition">
          <div class="filter-condition-title">完整复制所有PNR内容</div>
          <div class="filter-condition-language">
            <span style="margin-right: 8px">选择模板:</span>
            <el-select
              v-model="store.state.seledLetter"
              class="m-2"
              placeholder="Select"
            >
              <el-option
                v-for="item in letterList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
          <div class="filter-condition-language">
            <span>国内/国际:</span>
            <el-radio-group v-model="seledCountry" class="ml-4">
              <el-radio label="gn">国内</el-radio>
              <el-radio label="gj">国际</el-radio>
            </el-radio-group>
          </div>
          <div class="parse-btn-box">
            <span class="clear-btn" @click="clearPnrText"
              >清&nbsp;&nbsp;&nbsp;空</span
            >
            <span class="parse-btn" @click="ARNKGet"
              >提取资料</span
            >
          </div>
          <div class="hint-text">
            (用户提取资料成功后可在生成预览中编辑对应信息)
          </div>
        </div>
        <div class="itinerary-box">
          <div class="itinerary-left">
            <textarea
              class="pnr-text"
              v-model="PnrText"
              cols="30"
              rows="10"
            ></textarea>
          </div>
          <div class="itinerary-right">
            <div class="itinerary-right-title">生成预览：</div>
            <div
              class="itinerary-right-list"
              v-if="
                store.state.seledLetter == 'en' ||
                store.state.seledLetter == 'ch'
              "
              id="pdf-details"
            >
              <div class="list-header">
                <img :src="store.state.images.IATA_logo" class="IATA-logo" />
              </div>
              <hr />
              <div class="list-content">
                <div class="list-content-tltle">
                  {{
                    store.state.seledLetter == "en"
                      ? "ITINERARY"
                      : "电子客票行程单"
                  }}
                </div>
                <div
                  class="list-content-en-tltle"
                  v-if="store.state.seledLetter == 'chen'"
                >
                  ITINERARY
                </div>
                <div class="content-plane-msg">
                  <div class="plane-msg-row">
                    <div class="plane-msg-item">
                      <div class="plane-name">
                        {{
                          store.state.seledLetter == "en"
                            ? "AIRLINE PNR"
                            : store.state.seledLetter == "chen"
                            ? "航空公司记录编号 AIRLINE PNR"
                            : "航空公司记录编号"
                        }}:
                      </div>
                      <input
                        class="plane-text"
                        v-model="store.state.resolveData.AirlineBigCode"
                        type="text"
                        style="width: 40%"
                      />
                    </div>
                    <div class="plane-msg-item">
                      <div class="plane-name">
                        {{
                          store.state.seledLetter == "en"
                            ? "1E PNR"
                            : store.state.seledLetter == "chen"
                            ? "订座记录编号 1E PNR"
                            : "订座记录编号"
                        }}:
                      </div>
                      <input
                        class="plane-text"
                        v-model="store.state.resolveData.Pnr"
                        type="text"
                        style="width: 40%"
                      />
                    </div>
                  </div>
                  <div class="plane-msg-row">
                    <div class="plane-msg-item1">
                      <div class="plane-name">
                        {{
                          store.state.seledLetter == "en"
                            ? "NAME"
                            : store.state.seledLetter == "chen"
                            ? "旅客姓名 NAME"
                            : "旅客姓名"
                        }}:
                      </div>
                      <!-- <div  style="width:70%"> -->
                      <div
                        v-if="
                          store.state.resolveData.Tickets &&
                          store.state.resolveData.Tickets.length > 0
                        "
                        style="width: 70%"
                      >
                        <input
                          class="auto-box"
                          type="text"
                          v-for="(item, index) in store.state.resolveData
                            .Tickets"
                          :key="index"
                          v-model="item.PersonName"
                          style="width: 100%"
                        />
                      </div>
                      <!-- </div> -->
                    </div>
                    <div class="plane-msg-item1">
                      <div class="plane-name">
                        {{
                          store.state.seledLetter == "en"
                            ? "ETKT NBR"
                            : store.state.seledLetter == "chen"
                            ? "票号 ETKT NBR"
                            : "票号"
                        }}:
                      </div>
                      <!-- <div  style="width:70%"> -->
                      <div
                        v-if="
                          store.state.resolveData.Tickets &&
                          store.state.resolveData.Tickets.length > 0
                        "
                        style="width: 70%"
                      >
                        <input
                          class="auto-box"
                          v-for="(item, index) in store.state.resolveData
                            .Tickets"
                          :key="index"
                          v-model="item.TicketNo"
                          style="width: 100%"
                        />
                      </div>

                      <!-- </div> -->
                    </div>
                  </div>
                  <div class="plane-msg-row">
                    <div class="plane-msg-item1">
                      <div class="plane-name">
                        {{
                          store.state.seledLetter == "en"
                            ? "ID NUMBER"
                            : store.state.seledLetter == "chen"
                            ? "身份识别代码 ID NUMBER"
                            : "身份识别代码"
                        }}:
                      </div>
                      <!-- <div  style="width: 70%;"> -->
                      <div
                        v-if="
                          store.state.resolveData.Tickets &&
                          store.state.resolveData.Tickets.length > 0
                        "
                        style="width: 40%"
                      >
                        <input
                          class="auto-box"
                          v-for="(item, index) in store.state.resolveData
                            .Tickets"
                          :key="index"
                          v-model="item.Certificate"
                          style="width: 100%"
                        />
                      </div>

                      <!-- </div> -->
                    </div>
                    <div class="plane-msg-item">
                      <div class="plane-name">
                        {{
                          store.state.seledLetter == "en"
                            ? "CONJ NBR"
                            : store.state.seledLetter == "chen"
                            ? "联票 CONJ NBR"
                            : "联票"
                        }}:
                      </div>
                      <div class="auto-box" />
                    </div>
                  </div>
                  <div class="plane-msg-row">
                    <div class="plane-msg-item1">
                      <div class="plane-name">
                        {{
                          store.state.seledLetter == "en"
                            ? "ISSUING AIRLINE"
                            : store.state.seledLetter == "chen"
                            ? "出票航空公司 ISSUING AIRLINE"
                            : "出票航空公司"
                        }}:
                      </div>
                      <div
                        class="plane-text"
                        type="text"
                        contenteditable="true"
                        style="width: 45%; height: auto"
                      >
                        {{ store.state.resolveData.Airline }}
                      </div>
                    </div>
                    <div class="plane-msg-item">
                      <div class="plane-name">
                        {{
                          store.state.seledLetter == "en"
                            ? "DATE OF ISSUE"
                            : store.state.seledLetter == "chen"
                            ? "出票时间 DATE OF ISSUE"
                            : "出票时间"
                        }}:
                      </div>
                      <input
                        class="plane-text"
                        style="width: 45%"
                        v-model="store.state.resolveData.DateOfIssue"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="plane-msg-row">
                    <div class="plane-msg-item">
                      <div class="plane-name">
                        {{
                          store.state.seledLetter == "en"
                            ? "ISSUING AGENT"
                            : store.state.seledLetter == "chen"
                            ? "出票代理人 ISSUING AGENT"
                            : "出票代理人"
                        }}:
                      </div>
                      <input
                        class="plane-text"
                        style="width: 45%"
                        v-model="store.state.adminName"
                        type="text"
                      />
                    </div>
                    <div class="plane-msg-item">
                      <div class="plane-name">
                        {{
                          store.state.seledLetter == "en"
                            ? "IATA CODE"
                            : store.state.seledLetter == "chen"
                            ? "航协代码 IATA CODE"
                            : "航协代码"
                        }}:
                      </div>
                      <input
                        class="plane-text"
                        v-model="store.state.resolveData.AirNo"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="plane-msg-row">
                    <div class="plane-msg-item1" style="width: 100%">
                      <div class="plane-name">
                        {{
                          store.state.seledLetter == "en"
                            ? "AGENCY ADDRESS"
                            : store.state.seledLetter == "chen"
                            ? "代理人地址 AGENCY ADDRESS"
                            : "代理人地址"
                        }}:
                      </div>
                      <div
                        class="plane-text"
                        type="text"
                        contenteditable="true"
                        style="width: 70%; height: auto"
                      >
                        {{ address }}
                      </div>
                    </div>
                  </div>
                  <div class="plane-msg-row">
                    <div class="plane-msg-item">
                      <div class="plane-name">
                        {{
                          store.state.seledLetter == "en"
                            ? "TEL"
                            : store.state.seledLetter == "chen"
                            ? "电话 TEL"
                            : "电话"
                        }}:
                      </div>
                      <input
                        class="plane-text"
                        v-model="store.state.phone"
                        type="text"
                      />
                    </div>
                    <div class="plane-msg-item">
                      <div class="plane-name">
                        {{
                          store.state.seledLetter == "en"
                            ? "FAX"
                            : store.state.seledLetter == "chen"
                            ? "传真 FAX"
                            : "传真"
                        }}:
                      </div>
                      <input
                        class="plane-text"
                        v-model="store.state.fax"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div class="plane-msg-list">
                  <table class="flight-table">
                    <thead>
                      <tr>
                        <th
                          v-html="
                            store.state.seledLetter == 'en'
                              ? 'ORIGIN'
                              : store.state.seledLetter == 'chen'
                              ? '起飞机场\rORIGIN'
                              : '起飞机场'
                          "
                        ></th>
                        <th
                          v-html="
                            store.state.seledLetter == 'en'
                              ? 'DES'
                              : store.state.seledLetter == 'chen'
                              ? '到达机场\rDES'
                              : '到达机场'
                          "
                        ></th>
                        <th
                          v-html="
                            store.state.seledLetter == 'en'
                              ? 'FLIGHT'
                              : store.state.seledLetter == 'chen'
                              ? '航班\rFLIGHT'
                              : '航班'
                          "
                        ></th>
                        <th
                          v-html="
                            store.state.seledLetter == 'en'
                              ? 'CLASS'
                              : store.state.seledLetter == 'chen'
                              ? '舱位\rCLASS'
                              : '舱位'
                          "
                        ></th>
                        <th
                          v-html="
                            store.state.seledLetter == 'en'
                              ? 'DATE'
                              : store.state.seledLetter == 'chen'
                              ? '日期\rDATE'
                              : '日期'
                          "
                        ></th>
                        <th
                          v-html="
                            store.state.seledLetter == 'en'
                              ? 'DEPARTURE'
                              : store.state.seledLetter == 'chen'
                              ? '起飞\rTIME'
                              : '起飞'
                          "
                        ></th>
                        <th
                          v-html="
                            store.state.seledLetter == 'en'
                              ? 'ARRIVAL'
                              : store.state.seledLetter == 'chen'
                              ? '到达\rPERIOD'
                              : '到达'
                          "
                        ></th>
                        <th
                          v-html="
                            store.state.seledLetter == 'en'
                              ? 'STATUS'
                              : store.state.seledLetter == 'chen'
                              ? '状态\rSTATUS'
                              : '状态'
                          "
                        ></th>
                        <th
                          v-html="
                            store.state.seledLetter == 'en'
                              ? 'ALLOW'
                              : store.state.seledLetter == 'chen'
                              ? '行李\rALLOW'
                              : '行李'
                          "
                        ></th>
                        <th
                          v-html="
                            store.state.seledLetter == 'en'
                              ? 'TERMINAL Takeoff'
                              : store.state.seledLetter == 'chen'
                              ? '起飞航站楼\rTERMINAL Takeoff'
                              : '起飞航站楼'
                          "
                        ></th>
                        <th
                          v-html="
                            store.state.seledLetter == 'en'
                              ? 'TERMINAL Arrival'
                              : store.state.seledLetter == 'chen'
                              ? '到达航站楼\rTERMINAL Arrival'
                              : '到达航站楼'
                          "
                        ></th>
                      </tr>
                    </thead>
                    <tbody
                      class="flight-tbody"
                      v-if="
                        store.state.resolveData.Flights &&
                        store.state.resolveData.Flights.length > 0
                      "
                    >
                      <tr
                        v-for="(item, index) in store.state.resolveData.Flights"
                        :key="index"
                      >
                        <td contenteditable="true" v-html="item.Departure"></td>
                        <td
                          contenteditable="true"
                          v-html="item.Destination"
                        ></td>
                        <td contenteditable="true">{{ item.Flight }}</td>
                        <td contenteditable="true">{{ item.Position }}</td>
                        <td contenteditable="true" v-if="store.state.seledLetter == 'ch'">
                          {{
                            judgmentDate(item.FlightDate.slice(2)) == undefined
                              ? item.FlightDate
                              : judgmentDate(item.FlightDate.slice(2)) +
                                "-" +
                                item.FlightDate.slice(0, 2)
                          }}
                        </td>
                        <td contenteditable="true"  v-if="store.state.seledLetter !== 'ch'">
                          {{
                            item.FlightDate
                          }}
                        </td>
                        <td contenteditable="true">
                          {{
                            item.DepartureTime.slice(0, 2) +
                            ":" +
                            item.DepartureTime.slice(2, 4)
                          }}
                        </td>
                        <td contenteditable="true">
                          {{
                            item.DestinationTime.slice(0, 2) +
                            ":" +
                            item.DestinationTime.slice(2, 4) +
                            (item.ModifyDate == 0 ? "" : "+" + item.ModifyDate)
                          }}
                        </td>
                        <td contenteditable="true">{{ item.FlightStatus }}</td>
                        <td contenteditable="true">
                          {{ item.Luggage == "0" ? "" : item.Luggage }}
                        </td>
                        <td contenteditable="true">
                          {{ item.DepartureTerminal }}
                        </td>
                        <td contenteditable="true">
                          {{ item.DestinationTerminal }}
                        </td>
                      </tr>
                      <!-- 可以添加更多的航班信息行 -->
                    </tbody>
                  </table>
                </div>
                <hr />
                <div class="price-box">
                  <div class="price-item">
                    <span class="price-item-name"
                      >{{
                        store.state.seledLetter == "en"
                          ? "FARE"
                          : store.state.seledLetter == "chen"
                          ? "机票款 FARE"
                          : "机票款"
                      }}:</span
                    >
                    <input
                      class="price-item-input"
                      v-model="airTicketPrice"
                      type="text"
                    />
                  </div>
                  <div class="price-item">
                    <span class="price-item-name"
                      >{{
                        store.state.seledLetter == "en"
                          ? "TAX"
                          : store.state.seledLetter == "chen"
                          ? "税款 TAX"
                          : "税款"
                      }}:</span
                    >
                    <input
                      class="price-item-input"
                      v-model="taxes"
                      type="text"
                    />
                  </div>
                  <div class="price-item">
                    <span class="price-item-name"
                      >{{
                        store.state.seledLetter == "en"
                          ? "TOTAL"
                          : store.state.seledLetter == "chen"
                          ? "总额 TOTAL"
                          : "总额"
                      }}:</span
                    >
                    <input
                      class="price-item-input"
                      v-model="allPrice"
                      type="text"
                    />
                  </div>
                </div>
                <div class="hint-box">
                  <div class="hint-title">
                    {{
                      store.state.seledLetter == "en"
                        ? "Notice"
                        : store.state.seledLetter == "chen"
                        ? "须知 \rNotice"
                        : "须知"
                    }}:
                  </div>
                  <div
                    class="hint-item"
                    v-html="
                      store.state.seledLetter == 'en'
                        ? '· Please check the flight information again；'
                        : store.state.seledLetter == 'chen'
                        ? '· 请您再次核对航班信息；\r Please check the flight information again；'
                        : '· 请您再次核对航班信息'
                    "
                  ></div>
                  <div
                    class="hint-item"
                    v-html="
                      store.state.seledLetter == 'en'
                        ? '· The connecting ticket shall be used in sequence and shall not be used in skip section;'
                        : store.state.seledLetter == 'chen'
                        ? '· 联程客票须按顺序使用，不得跳段使用；\r The connecting ticket shall be used in sequence and shall not be used in skip section;'
                        : '· 联程客票须按顺序使用，不得跳段使用；'
                    "
                  ></div>
                  <div
                    class="hint-item"
                    v-html="
                      store.state.seledLetter == 'en'
                        ? '· Please confirm that your passport is valid for at least half a year;'
                        : store.state.seledLetter == 'chen'
                        ? '· 请确认您的护照有效期至少在半年以上；\r Please confirm that your passport is valid for at least half a year;'
                        : '· 请确认您的护照有效期至少在半年以上；'
                    "
                  ></div>
                  <div
                    class="hint-item"
                    v-html="
                      store.state.seledLetter == 'en'
                        ? '· For international flights, please arrive at the airport at least 3 hours before departure and check in;'
                        : store.state.seledLetter == 'chen'
                        ? '· 国际航班请您至少在航班起飞前3小时到达机场，并且办理乘机手续；\r For international flights, please arrive at the airport at least 3 hours before departure and check in;'
                        : '· 国际航班请您至少在航班起飞前3小时到达机场，并且办理乘机手续；'
                    "
                  ></div>
                  <div
                    class="hint-item"
                    v-html="
                      store.state.seledLetter == 'en'
                        ? '· Please reconfirm your itinerary 72 hours before departure.'
                        : store.state.seledLetter == 'chen'
                        ? '· 请您在航班起飞前72小时再次确认您的行程。\r Please reconfirm your itinerary 72 hours before departure.'
                        : '· 请您在航班起飞前72小时再次确认您的行程。'
                    "
                  ></div>
                  <div
                    class="hint-item"
                    v-html="
                      store.state.seledLetter == 'en'
                        ? '· Please check the flight information again, ticket is valid for one year.'
                        : store.state.seledLetter == 'chen'
                        ? '· 请您再次核对航班信息,机票自出票日起一年有效。\r Please check the flight information again, ticket is valid for one year.'
                        : '· 请您再次核对航班信息,机票自出票日起一年有效。'
                    "
                  ></div>
                </div>
              </div>
            </div>
            <ChEnOrder
              v-if="store.state.seledLetter == 'chen'"
              ref="manyChEnorder"
            ></ChEnOrder>
            <CHElegant
              id="pdf-CHElegant"
              v-if="
                store.state.seledLetter == 'chdianya' ||
                store.state.seledLetter == 'endianya'
              "
              ref="bigCHElegantBox"
            ></CHElegant>
            <Table
              ref="manyTable"
              v-if="
                store.state.seledLetter == 'chTable' ||
                store.state.seledLetter == 'enTable'
              "
            ></Table>
            <Newelegant
              ref="manyNewElegant"
              v-if="
                store.state.seledLetter == 'newEnDianya' ||
                store.state.seledLetter == 'newChDianya'
              "
            ></Newelegant>
          </div>
        </div>
      </div>
      <div class="put-xing-cheng">
        <span>类型:</span>
        <el-radio-group
          v-model="store.state.seledPDF"
          @change="change"
          class="ml-4"
        >
          <el-radio label="one">独立</el-radio>
          <el-radio label="many">多人</el-radio>
        </el-radio-group>
        <div
          class="generate-btn"
          v-if="
            store.state.seledLetter == 'en' || store.state.seledLetter == 'ch'
          "
          @click="TypeExportToWord"
        >
          生成Word行程单
        </div>
        <div class="generate-btn" @click="generateXingChengDan">
          生成PDF行程单
        </div>
      </div>
    </div>
    <!-- <div v-if="store.state.seledLetter == 'chen'">
      <OneChEnOrder ref="oneChEnOrder"></OneChEnOrder>
    </div> -->
    <div
      v-if="
        store.state.seledLetter == 'chdianya' ||
        store.state.seledLetter == 'endianya'
      "
    >
      <!-- <OneCHElegant ref="oneCHElegantBox"></OneCHElegant> -->
    </div>
    <!-- <div v-if="
        store.state.seledLetter == 'chTable' ||
        store.state.seledLetter == 'enTable'
      ">
      <OneTable ref="oneTable"></OneTable>
    </div> -->
    <!-- <div v-if="store.state.seledLetter == 'newChDianya' ||
        store.state.seledLetter == 'newEnDianya'">
      <OneNewElegant ref="oneNewElegant"></OneNewElegant>
    </div> -->
    <div
      v-if="
        store.state.seledLetter == 'chen' ||
        store.state.seledLetter == 'en' ||
        store.state.seledLetter == 'ch'
      "
    >
      <div
        class="itinerary-right-list"
        :id="`one-pdf-details${index}`"
        v-for="(item, index) in store.state.resolveData.Tickets"
        :key="index"
        style="
          width: 773px;
          position: absolute;
          z-index: 1;
          top: 50px;
          left: 32px;
        "
      >
        <div class="list-header">
          <img :src="store.state.images.IATA_logo" class="IATA-logo" />
        </div>
        <hr />
        <div class="list-content">
          <div class="list-content-tltle">
            {{
              store.state.seledLetter == "en" ? "ITINERARY" : "电子客票行程单"
            }}
          </div>
          <div
            class="list-content-en-tltle"
            v-if="store.state.seledLetter == 'chen'"
          >
            ITINERARY
          </div>
          <div class="content-plane-msg">
            <div class="plane-msg-row">
              <div class="plane-msg-item">
                <div class="plane-name">
                  {{
                    store.state.seledLetter == "en"
                      ? "AIRLINE PNR"
                      : store.state.seledLetter == "chen"
                      ? "航空公司记录编号 AIRLINE PNR"
                      : "航空公司记录编号"
                  }}:
                </div>
                <input
                  class="plane-text"
                  v-model="store.state.resolveData.AirlineBigCode"
                  type="text"
                  style="width: 40%"
                />
              </div>
              <div class="plane-msg-item">
                <div class="plane-name">
                  {{
                    store.state.seledLetter == "en"
                      ? "1E PNR"
                      : store.state.seledLetter == "chen"
                      ? "订座记录编号 1E PNR"
                      : "订座记录编号"
                  }}:
                </div>
                <input
                  class="plane-text"
                  v-model="store.state.resolveData.Pnr"
                  type="text"
                  style="width: 40%"
                />
              </div>
            </div>
            <div class="plane-msg-row">
              <div class="plane-msg-item1">
                <div class="plane-name">
                  {{
                    store.state.seledLetter == "en"
                      ? "NAME"
                      : store.state.seledLetter == "chen"
                      ? "旅客姓名 NAME"
                      : "旅客姓名"
                  }}:
                </div>
                <!-- <div  style="width:70%"> -->
                <div
                  v-if="
                    store.state.resolveData.Tickets &&
                    store.state.resolveData.Tickets.length > 0
                  "
                  style="width: 70%"
                >
                  <input
                    class="auto-box"
                    type="text"
                    v-model="store.state.resolveData.Tickets[index].PersonName"
                    style="width: 100%"
                  />
                </div>
                <!-- </div> -->
              </div>
              <div class="plane-msg-item1">
                <div class="plane-name">
                  {{
                    store.state.seledLetter == "en"
                      ? "ETKT NBR"
                      : store.state.seledLetter == "chen"
                      ? "票号 ETKT NBR"
                      : "票号"
                  }}:
                </div>
                <!-- <div  style="width:70%"> -->
                <div
                  v-if="
                    store.state.resolveData.Tickets &&
                    store.state.resolveData.Tickets.length > 0
                  "
                  style="width: 70%"
                >
                  <input
                    class="auto-box"
                    v-model="store.state.resolveData.Tickets[index].TicketNo"
                    style="width: 100%"
                  />
                </div>

                <!-- </div> -->
              </div>
            </div>
            <div class="plane-msg-row">
              <div class="plane-msg-item1">
                <div class="plane-name">
                  {{
                    store.state.seledLetter == "en"
                      ? "ID NUMBER"
                      : store.state.seledLetter == "chen"
                      ? "身份识别代码 ID NUMBER"
                      : "身份识别代码"
                  }}:
                </div>
                <!-- <div  style="width: 70%;"> -->
                <div
                  v-if="
                    store.state.resolveData.Tickets &&
                    store.state.resolveData.Tickets.length > 0
                  "
                  style="width: 40%"
                >
                  <input
                    class="auto-box"
                    v-model="store.state.resolveData.Tickets[index].Certificate"
                    style="width: 100%"
                  />
                </div>

                <!-- </div> -->
              </div>
              <div class="plane-msg-item">
                <div class="plane-name">
                  {{
                    store.state.seledLetter == "en"
                      ? "CONJ NBR"
                      : store.state.seledLetter == "chen"
                      ? "联票 CONJ NBR"
                      : "联票"
                  }}:
                </div>
                <div class="auto-box" />
              </div>
            </div>
            <div class="plane-msg-row">
              <div class="plane-msg-item1">
                <div class="plane-name">
                  {{
                    store.state.seledLetter == "en"
                      ? "ISSUING AIRLINE"
                      : store.state.seledLetter == "chen"
                      ? "出票航空公司 ISSUING AIRLINE"
                      : "出票航空公司"
                  }}:
                </div>
                <div
                  class="plane-text"
                  type="text"
                  contenteditable="true"
                  style="width: 45%; height: auto"
                >
                  {{ store.state.resolveData.Airline }}
                </div>
              </div>
              <div class="plane-msg-item">
                <div class="plane-name">
                  {{
                    store.state.seledLetter == "en"
                      ? "DATE OF ISSUE"
                      : store.state.seledLetter == "chen"
                      ? "出票时间 DATE OF ISSUE"
                      : "出票时间"
                  }}:
                </div>
                <input
                  class="plane-text"
                  style="width: 45%"
                  v-model="store.state.resolveData.DateOfIssue"
                  type="text"
                />
              </div>
            </div>
            <div class="plane-msg-row">
              <div class="plane-msg-item">
                <div class="plane-name">
                  {{
                    store.state.seledLetter == "en"
                      ? "ISSUING AGENT"
                      : store.state.seledLetter == "chen"
                      ? "出票代理人 ISSUING AGENT"
                      : "出票代理人"
                  }}:
                </div>
                <input
                  class="plane-text"
                  style="width: 45%"
                  v-model="store.state.adminName"
                  type="text"
                />
              </div>
              <div class="plane-msg-item">
                <div class="plane-name">
                  {{
                    store.state.seledLetter == "en"
                      ? "IATA CODE"
                      : store.state.seledLetter == "chen"
                      ? "航协代码 IATA CODE"
                      : "航协代码"
                  }}:
                </div>
                <input
                  class="plane-text"
                  v-if="store.state.resolveData.AirNo"
                  v-model="store.state.resolveData.AirNo"
                  type="text"
                />
              </div>
            </div>
            <div class="plane-msg-row">
              <div class="plane-msg-item1" style="width: 100%">
                <div class="plane-name">
                  {{
                    store.state.seledLetter == "en"
                      ? "AGENCY ADDRESS"
                      : store.state.seledLetter == "chen"
                      ? "代理人地址 AGENCY ADDRESS"
                      : "代理人地址"
                  }}:
                </div>
                <div
                  class="plane-text"
                  type="text"
                  contenteditable="true"
                  style="width: 70%; height: auto"
                >
                  {{ address }}
                </div>
              </div>
            </div>
            <div class="plane-msg-row">
              <div class="plane-msg-item">
                <div class="plane-name">
                  {{
                    store.state.seledLetter == "en"
                      ? "TEL"
                      : store.state.seledLetter == "chen"
                      ? "电话 TEL"
                      : "电话"
                  }}:
                </div>
                <input
                  class="plane-text"
                  v-model="store.state.phone"
                  type="text"
                />
              </div>
              <div class="plane-msg-item">
                <div class="plane-name">
                  {{
                    store.state.seledLetter == "en"
                      ? "FAX"
                      : store.state.seledLetter == "chen"
                      ? "传真 FAX"
                      : "传真"
                  }}:
                </div>
                <input
                  class="plane-text"
                  v-model="store.state.fax"
                  type="text"
                />
              </div>
            </div>
          </div>
          <hr />
          <div class="plane-msg-list">
            <table class="flight-table">
              <thead>
                <tr>
                  <th
                    v-html="
                      store.state.seledLetter == 'en'
                        ? 'ORIGIN'
                        : store.state.seledLetter == 'chen'
                        ? '起飞机场\rORIGIN'
                        : '起飞机场'
                    "
                  ></th>
                  <th
                    v-html="
                      store.state.seledLetter == 'en'
                        ? 'DES'
                        : store.state.seledLetter == 'chen'
                        ? '到达机场\rDES'
                        : '到达机场'
                    "
                  ></th>
                  <th
                    v-html="
                      store.state.seledLetter == 'en'
                        ? 'FLIGHT'
                        : store.state.seledLetter == 'chen'
                        ? '航班\rFLIGHT'
                        : '航班'
                    "
                  ></th>
                  <th
                    v-html="
                      store.state.seledLetter == 'en'
                        ? 'CLASS'
                        : store.state.seledLetter == 'chen'
                        ? '舱位\rCLASS'
                        : '舱位'
                    "
                  ></th>
                  <th
                    v-html="
                      store.state.seledLetter == 'en'
                        ? 'DATE'
                        : store.state.seledLetter == 'chen'
                        ? '日期\rDATE'
                        : '日期'
                    "
                  ></th>
                  <th
                    v-html="
                      store.state.seledLetter == 'en'
                        ? 'TIME'
                        : store.state.seledLetter == 'chen'
                        ? '起飞\rTIME'
                        : '起飞'
                    "
                  ></th>
                  <th
                    v-html="
                      store.state.seledLetter == 'en'
                        ? 'PERIOD'
                        : store.state.seledLetter == 'chen'
                        ? '到达\rPERIOD'
                        : '到达'
                    "
                  ></th>
                  <th
                    v-html="
                      store.state.seledLetter == 'en'
                        ? 'STATUS'
                        : store.state.seledLetter == 'chen'
                        ? '状态\rSTATUS'
                        : '状态'
                    "
                  ></th>
                  <th
                    v-html="
                      store.state.seledLetter == 'en'
                        ? 'ALLOW'
                        : store.state.seledLetter == 'chen'
                        ? '行李\rALLOW'
                        : '行李'
                    "
                  ></th>
                  <th
                    v-html="
                      store.state.seledLetter == 'en'
                        ? 'TERMINAL Takeoff'
                        : store.state.seledLetter == 'chen'
                        ? '起飞航站楼\rTERMINAL Takeoff'
                        : '起飞航站楼'
                    "
                  ></th>
                  <th
                    v-html="
                      store.state.seledLetter == 'en'
                        ? 'TERMINAL Arrival'
                        : store.state.seledLetter == 'chen'
                        ? '到达航站楼\rTERMINAL Arrival'
                        : '到达航站楼'
                    "
                  ></th>
                </tr>
              </thead>
              <tbody
                class="flight-tbody"
                v-if="
                  store.state.resolveData.Flights &&
                  store.state.resolveData.Flights.length > 0
                "
              >
                <tr
                  v-for="(item, index) in store.state.resolveData.Flights"
                  :key="index"
                >
                  <td contenteditable="true">{{ item.Departure }}</td>
                  <td contenteditable="true">{{ item.Destination }}</td>
                  <td contenteditable="true">{{ item.Flight }}</td>
                  <td contenteditable="true">{{ item.Position }}</td>
                  <td contenteditable="true" v-if="store.state.seledLetter !== 'en'">
                    {{
                      judgmentDate(item.FlightDate.slice(2)) == undefined
                        ? item.FlightDate
                        : judgmentDate(item.FlightDate.slice(2)) +
                          "-" +
                          item.FlightDate.slice(0, 2)
                    }}
                  </td>
                  <td contenteditable="true" v-if="store.state.seledLetter == 'en'">
                    {{
                      item.FlightDate
                    }}
                  </td>
                  <td contenteditable="true">
                    {{
                      item.DepartureTime.slice(0, 2) +
                      ":" +
                      item.DepartureTime.slice(2, 4)
                    }}
                  </td>
                  <td contenteditable="true">
                    {{
                      item.DestinationTime.slice(0, 2) +
                      ":" +
                      item.DestinationTime.slice(2, 4) +
                      (item.ModifyDate == 0 ? "" : "+" + item.ModifyDate)
                    }}
                  </td>
                  <td contenteditable="true">{{ item.FlightStatus }}</td>
                  <td contenteditable="true">
                    {{ item.Luggage == "0" ? "" : item.Luggage }}
                  </td>
                  <td contenteditable="true">{{ item.DepartureTerminal }}</td>
                  <td contenteditable="true">{{ item.DestinationTerminal }}</td>
                </tr>
                <!-- 可以添加更多的航班信息行 -->
              </tbody>
            </table>
          </div>
          <hr />
          <div class="price-box">
            <div class="price-item">
              <span class="price-item-name"
                >{{
                  store.state.seledLetter == "en"
                    ? "FARE"
                    : store.state.seledLetter == "chen"
                    ? "机票款 FARE"
                    : "机票款"
                }}:</span
              >
              <input
                class="price-item-input"
                v-model="airTicketPrice"
                type="text"
              />
            </div>
            <div class="price-item">
              <span class="price-item-name"
                >{{
                  store.state.seledLetter == "en"
                    ? "TAX"
                    : store.state.seledLetter == "chen"
                    ? "税款 TAX"
                    : "税款"
                }}:</span
              >
              <input class="price-item-input" v-model="taxes" type="text" />
            </div>
            <div class="price-item">
              <span class="price-item-name"
                >{{
                  store.state.seledLetter == "en"
                    ? "TOTAL"
                    : store.state.seledLetter == "chen"
                    ? "总额 TOTAL"
                    : "总额"
                }}:</span
              >
              <input class="price-item-input" v-model="allPrice" type="text" />
            </div>
          </div>
          <div class="hint-box">
            <div class="hint-title">
              {{
                store.state.seledLetter == "en"
                  ? "Notice"
                  : store.state.seledLetter == "chen"
                  ? "须知 \rNotice"
                  : "须知"
              }}:
            </div>
            <div
              class="hint-item"
              v-html="
                store.state.seledLetter == 'en'
                  ? '· Please check the flight information again；'
                  : store.state.seledLetter == 'chen'
                  ? '· 请您再次核对航班信息；\r Please check the flight information again；'
                  : '· 请您再次核对航班信息'
              "
            ></div>
            <div
              class="hint-item"
              v-html="
                store.state.seledLetter == 'en'
                  ? '· The connecting ticket shall be used in sequence and shall not be used in skip section;'
                  : store.state.seledLetter == 'chen'
                  ? '· 联程客票须按顺序使用，不得跳段使用；\r The connecting ticket shall be used in sequence and shall not be used in skip section;'
                  : '· 联程客票须按顺序使用，不得跳段使用；'
              "
            ></div>
            <div
              class="hint-item"
              v-html="
                store.state.seledLetter == 'en'
                  ? '· Please confirm that your passport is valid for at least half a year;'
                  : store.state.seledLetter == 'chen'
                  ? '· 请确认您的护照有效期至少在半年以上；\r Please confirm that your passport is valid for at least half a year;'
                  : '· 请确认您的护照有效期至少在半年以上；'
              "
            ></div>
            <div
              class="hint-item"
              v-html="
                store.state.seledLetter == 'en'
                  ? '· For international flights, please arrive at the airport at least 3 hours before departure and check in;'
                  : store.state.seledLetter == 'chen'
                  ? '· 国际航班请您至少在航班起飞前3小时到达机场，并且办理乘机手续；\r For international flights, please arrive at the airport at least 3 hours before departure and check in;'
                  : '· 国际航班请您至少在航班起飞前3小时到达机场，并且办理乘机手续；'
              "
            ></div>
            <div
              class="hint-item"
              v-html="
                store.state.seledLetter == 'en'
                  ? '· Please reconfirm your itinerary 72 hours before departure.'
                  : store.state.seledLetter == 'chen'
                  ? '· 请您在航班起飞前72小时再次确认您的行程。\r Please reconfirm your itinerary 72 hours before departure.'
                  : '· 请您在航班起飞前72小时再次确认您的行程。'
              "
            ></div>
            <div
              class="hint-item"
              v-html="
                store.state.seledLetter == 'en'
                  ? '· Please check the flight information again, ticket is valid for one year.'
                  : store.state.seledLetter == 'chen'
                  ? '· 请您再次核对航班信息,机票自出票日起一年有效。\r Please check the flight information again, ticket is valid for one year.'
                  : '· 请您再次核对航班信息,机票自出票日起一年有效。'
              "
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { nextTick, reactive, ref } from "vue";
import CHElegant from "../components/CHElegant.vue";
// import OneCHElegant from "../components/OneCHElegant.vue";
import htmlPdf from "@/utils/pdf.js";
import axios from "../utils/axios";
import Table from "../components/Table.vue";
// import OneTable from "../components/OneTable.vue"
import { useStore } from "vuex";
import { exportWord } from "../utils/exportDocx";
import { ElMessageBox, ElLoading } from "element-plus";
import Newelegant from "../components/Newelegant.vue";
// import OneNewElegant from "../components/OneNewElegant.vue"
import ChEnOrder from "../components/ChEnOrder.vue";
// import OneChEnOrder from "../components/OneChEnOrder.vue"

const store = useStore();

const address = ref("");

const airTicketPrice = ref("0");
const containerRef = ref(null);

const letterList = reactive([
  {
    label: "中文",
    value: "ch",
  },
  {
    label: "英文",
    value: "en",
  },
  {
    label: "中英",
    value: "chen",
  },
  {
    label: "中文典雅",
    value: "chdianya",
  },
  {
    label: "英文典雅",
    value: "endianya",
  },
  {
    label: "中文表格",
    value: "chTable",
  },
  {
    label: "英文表格",
    value: "enTable",
  },
  {
    label: "新中文典雅",
    value: "newChDianya",
  },
  {
    label: "新英文典雅",
    value: "newEnDianya",
  },
]);

const taxes = ref("0");

const PnrText = ref("");

const bigCHElegantBox = ref(null);
// const oneCHElegantBox = ref(null);
const manyTable = ref(null);
// const oneTable = ref(null)
const manyNewElegant = ref(null);
// const oneNewElegant = ref(null)
const manyChEnorder = ref(null);
// const oneChEnOrder = ref(null)

const allPrice = ref("0");
const pdfIndex = ref(0);

const seledCountry = ref("gn");

function judgmentDate(text) {
  let moonList = [
    {
      name: "JAN",
      num: "01",
    },
    {
      name: "FEB",
      num: "02",
    },
    {
      name: "MAR",
      num: "03",
    },
    {
      name: "APR",
      num: "04",
    },
    {
      name: "MAY",
      num: "05",
    },
    {
      name: "JUN",
      num: "06",
    },
    {
      name: "JUL",
      num: "07",
    },
    {
      name: "AUG",
      num: "08",
    },
    {
      name: "SEP",
      num: "09",
    },
    {
      name: "OCT",
      num: "10",
    },
    {
      name: "NOV",
      num: "11",
    },
    {
      name: "DEC",
      num: "12",
    },
  ];
  let content = "";
  moonList.forEach((element) => {
    if (element.name.toUpperCase() == text.toUpperCase()) {
      content = element.num;
    }
  });
  return content;
}

function change(e) {
  store.state.dataTickets = [];
  if (e == "one") {
    store.state.dataTickets.push(store.state.resolveData.Tickets[0]);
  } else {
    store.state.dataTickets.push(store.state.resolveData.Tickets[0]);
    store.state.dataTickets = store.state.resolveData.Tickets;
  }
}

function generateXingChengDan() {
  let TypeName = "电子行程单";
  pdfIndex.value = 0;
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  if (store.state.seledPDF == "many") {
    if (
      store.state.seledLetter == "chdianya" ||
      store.state.seledLetter == "endianya"
    ) {
      bigCHElegantBox.value.childPDF();
    }
    if (
      store.state.seledLetter == "chTable" ||
      store.state.seledLetter == "enTable"
    ) {
      manyTable.value.childPDF();
    }

    if (
      store.state.seledLetter == "newChDianya" ||
      store.state.seledLetter == "newEnDianya"
    ) {
      manyNewElegant.value.childPDF();
    }
    if (store.state.seledLetter == "chen") {
      manyChEnorder.value.childPDF();
    }
    if (store.state.seledLetter == "en" || store.state.seledLetter == "ch") {
      htmlPdf(TypeName, document.querySelector("#pdf-details"));
    }
  } else if ((store.state.seledPDF = "one")) {
    if (store.state.seledLetter == "chen") {
      manyChEnorder.value.childPDF();
    }
    if (
      store.state.seledLetter == "endianya" ||
      store.state.seledLetter == "chdianya"
    ) {
      bigCHElegantBox.value.childPDF();
    }
    if (
      store.state.seledLetter == "chTable" ||
      store.state.seledLetter == "enTable"
    ) {
      manyTable.value.childPDF();
    }
    if (
      store.state.seledLetter == "newChDianya" ||
      store.state.seledLetter == "newEnDianya"
    ) {
      manyNewElegant.value.childPDF();
    }
    store.state.resolveData.Tickets.forEach((element, index) => {
      if (store.state.seledLetter == "en" || store.state.seledLetter == "ch") {
        htmlPdf(
          element.PersonName + TypeName,
          document.querySelector(`#one-pdf-details${index}`)
        );
      }
    });
  }
  window._hmt.push(["_trackEvent", "PDF", "click", "1-3"]);
}

function clearPnrText() {
  PnrText.value = "";
}

function chen() {
  const loading = ElLoading.service({
    lock: true,
    text: "正在提取...",
    background: "rgba(0, 0, 0, 0.7)",
  });
  axios
    .requestPost("/api/Print/RTGeneratePNR", {
      PnrType: seledCountry.value,
      LgType: "ch",
      PnrText: PnrText.value,
    })
    .then((res) => {
      if (res.status == "True") {
        store.state.resolveData = res.items;
        store.state.dataTickets = store.state.resolveData.Tickets;
        axios
          .requestPost("/api/Print/RTGeneratePNR", {
            PnrType: seledCountry.value,
            LgType: "en",
            PnrText: PnrText.value,
          })
          .then((restwo) => {
            loading.close();
            if (restwo.status == "True") {
              store.state.resolveData.Airline =
                store.state.resolveData.Airline + restwo.items.Airline;
              store.state.resolveData.Flights.forEach((element, index) => {
                element.Departure =
                  element.Departure +
                  "\r" +
                  restwo.items.Flights[index].Departure;
                element.Destination =
                  element.Destination +
                  "\r" +
                  restwo.items.Flights[index].Destination;
              });
            } else {
              ElMessageBox.alert(res.msg, "提示", {
                confirmButtonText: "OK",
              });
            }
          })
          .catch((err) => {
            loading.close();
            ElMessageBox.alert("提取异常，请稍后再试", "提示", {
              confirmButtonText: "OK",
            });
          });
      } else {
        loading.close();
        ElMessageBox.alert(res.msg, "提示", {
          confirmButtonText: "OK",
        });
      }
    })
    .catch((err) => {
      loading.close();
      ElMessageBox.alert("提取异常，请稍后再试", "提示", {
        confirmButtonText: "OK",
      });
    });
}

function ARNKGet() {
  if (PnrText.value.indexOf("ARNK") > -1) {
    ElMessageBox.alert(
      '您的PNR文本携带"ARNK"字段,如若继续将自动删除该文本',
      "提示",
      {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        showCancelButton: true,
        beforeClose: (action, instance, done) => {
          if (action === "cancel") {
            done();
          } else {
            PnrText.value = PnrText.value.replace(new RegExp("ARNK", "g"), "");
            activeGetRTGeneratePNR();
            done();
          }
        },
      }
    );
  } else {
    activeGetRTGeneratePNR();
  }
}

function activeGetRTGeneratePNR() {
  window._hmt.push(["_trackEvent", "parsePNR", "click", "1-1"]);
  store.state.seledPDF = "many";
  if (store.state.seledLetter == "chen") {
    chen();
  } else {
    const loading = ElLoading.service({
      lock: true,
      text: "正在提取...",
      background: "rgba(0, 0, 0, 0.7)",
    });
    // let abc = JSON.stringify({
    //   PnrType:seledCountry.value,
    //   LgType:"ch",
    //   PnrText:PnrText.value
    // })
    // console.log(abc)
    axios
      .requestPost("/api/Print/RTGeneratePNR", {
        PnrType: seledCountry.value,
        LgType:
          store.state.seledLetter == "chdianya" ||
          store.state.seledLetter == "chTable" ||
          store.state.seledLetter == "newChDianya"
            ? "ch"
            : store.state.seledLetter == "endianya" ||
              store.state.seledLetter == "enTable" ||
              store.state.seledLetter == "newEnDianya"
            ? "en"
            : store.state.seledLetter,
        PnrText: PnrText.value,
      })
      .then((res) => {
        loading.close();
        if (res.status == "True") {
          store.state.resolveData = res.items;
          store.state.dataTickets = store.state.resolveData.Tickets;
        } else {
          ElMessageBox.alert(res.msg, "提示", {
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        loading.close();
        ElMessageBox.alert("提取异常，请稍后再试", "提示", {
          confirmButtonText: "OK",
        });
      });
  }
}

function TypeExportToWord() {
  if (store.state.seledPDF == "many") {
    exportToWord();
  } else if ((store.state.seledPDF = "one")) {
    let tickets = store.state.resolveData.Tickets;
    tickets.forEach((element, index) => {
      let ticketlist = [];
      if (element.TicketNo == null || !element.TicketNo) {
        element.TicketNo = "";
      }
      if (element.PersonName == null || !element.PersonName) {
        element.PersonName = "";
      }
      if (element.Certificate == null || !element.Certificate) {
        element.Certificate = "";
      }
      ticketlist.push(tickets[index]);
      let data = {
        AirlineBigCode: store.state.resolveData.AirlineBigCode || "",
        Pnr: store.state.resolveData.Pnr || "",
        TicketsListName: ticketlist,
        TicketsListNo: ticketlist,
        TicketsListId: ticketlist,
        Airline: store.state.resolveData.Airline || "",
        DateOfIssue: store.state.resolveData.DateOfIssue || "",
        adminName: store.state.adminName || "",
        AirNo: store.state.resolveData.AirNo || "",
        address: address.value || "",
        phone: store.state.phone || "",
        fax: store.state.fax || "",
        Flights: store.state.resolveData.Flights || "",
        airTicketPrice: airTicketPrice.value,
        taxes: taxes.value,
        allPrice: allPrice.value,
      };
      if (store.state.seledLetter == "en") {
        exportWord(
          "/en电子行程单.docx",
          data,
          `${element.PersonName}电子行程单`
        );
      } else if (store.state.seledLetter == "ch") {
        exportWord("/电子行程单.docx", data, `${element.PersonName}电子行程单`);
      }
    });
  }
  window._hmt.push(["_trackEvent", "word", "click", "1-2"]);
}

function exportToWord() {
  let tickets = store.state.resolveData.Tickets;
  if (tickets.length > 0) {
    tickets.forEach((element) => {
      if (element.TicketNo == null || !element.TicketNo) {
        element.TicketNo = "";
      }
      if (element.PersonName == null || !element.PersonName) {
        element.PersonName = "";
      }
      if (element.Certificate == null || !element.Certificate) {
        element.Certificate = "";
      }
    });
  }
  let data = {
    AirlineBigCode: store.state.resolveData.AirlineBigCode || "",
    Pnr: store.state.resolveData.Pnr || "",
    TicketsListName: tickets,
    TicketsListNo: tickets,
    TicketsListId: tickets,
    Airline: store.state.resolveData.Airline || "",
    DateOfIssue: store.state.resolveData.DateOfIssue || "",
    adminName: store.state.adminName || "",
    AirNo: store.state.resolveData.AirNo || "",
    address: address.value || "",
    phone: store.state.phone || "",
    fax: store.state.fax || "",
    Flights: store.state.resolveData.Flights || "",
    airTicketPrice: airTicketPrice.value,
    taxes: taxes.value,
    allPrice: allPrice.value,
  };

  if (store.state.seledLetter == "en") {
    exportWord("/en电子行程单.docx", data, "en电子行程单");
  } else if (store.state.seledLetter == "ch") {
    exportWord("/电子行程单.docx", data, "电子行程单");
  }
}
</script>

<style scoped>
.home {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: 15px;
  z-index: 2;
  background-color: #fff;
}

#pdf-CHElegant {
  position: relative;
}

.home-content {
  width: 100%;
  border: 1px solid #ddd;
  position: relative;
  z-index: 2;
  padding-bottom: 48px;
  background-color: #fff;
}

.home-header {
  width: 100%;
  color: #333;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  padding: 8px 15px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.list-icon {
  width: 16px;
  height: 14px;
}

.header-title-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  font-size: 14px;
  color: #333;
  font-weight: 700;
  margin-left: 8px;
}

.jump-old-title {
  color: blue;
}

.jump-old-title:hover {
  border-bottom: 1px solid blue;
}

.home-content-itinerary {
  width: 100%;
  padding: 15px;
  position: relative;
  z-index: 2;
  background-color: #fff;
}

.filter-condition {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #888;
  background-color: #f7f7f7;
}

.filter-condition-title {
  color: #b16a68;
  font-weight: 700;
}

.filter-condition-language {
  display: flex;
  margin-left: 32px;
  justify-content: flex-start;
  align-items: center;
}

:deep(.el-radio) {
  margin-right: 4px;
}

:deep(.el-radio__label) {
  padding: 0;
  font-size: 12px;
}

.el-radio-group {
  margin-left: 4px;
}

.parse-btn-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 20px;
}

.clear-btn {
  background: #209e91;
  color: #fff;
  box-shadow: 1px 1px 5px #088679;
  border-radius: 3px;
  text-shadow: 1px 1px 1px #9e3f3f;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  padding: 6px 25px;
  text-align: center;
}

.parse-btn {
  margin-left: 15px;
  background-color: #e27575;
  color: #fff;
  box-shadow: 1px 1px 5px #e27575;
  border-radius: 3px;
  text-shadow: 1px 1px 1px #e27575;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  padding: 6px 25px;
  text-align: center;
}

.itinerary-box {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
}

.itinerary-left {
  width: 45%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.pnr-text {
  width: 100%;
  height: 800px;
  background-color: #000;
  color: springgreen;
  padding: 6px 12px;
  font-weight: 600;
  font-size: 14px;
  resize: none;
}

.pnr-text::-webkit-scrollbar {
  width: 12px;
}

.pnr-text::-webkit-scrollbar-thumb {
  background-color: #888; /* 滚动条拖动部分的颜色 */
  border-radius: 6px; /* 滚动条拖动部分的圆角 */
}

/* 适用于 Firefox 浏览器 */
.pnr-text::-moz-scrollbar {
  width: 12px; /* 滚动条宽度 */
}

.pnr-text::-moz-scrollbar-thumb {
  background-color: #888; /* 滚动条拖动部分的颜色 */
  border-radius: 6px; /* 滚动条拖动部分的圆角 */
}

.itinerary-right {
  width: 53%;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: flex-start;
}

.itinerary-right-title {
  font-size: 16px;
  width: 20%;
}

.itinerary-right-list {
  width: 80%;
  padding: 20px 0;
}

.list-header {
  width: 100%;
}

.IATA-logo {
  width: 84px;
  height: 59px;
}

.list-content {
  width: 100%;
  color: #000;
}

.list-content-tltle {
  width: 100%;
  text-align: center;
  font-size: 20px;
  margin-top: 16px;
  font-weight: 600;
}

.list-content-en-tltle {
  width: 100%;
  font-size: 18px;
  margin-top: 8px;
  text-align: center;
  font-weight: 600;
}

.content-plane-msg {
  width: 100%;
  margin-top: 40px;
}

.plane-msg-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 8px;
}

.plane-msg-item {
  width: 45%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
}

.plane-msg-item1 {
  width: 45%;
  display: flex;
  flex-flow: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 14px;
}

.plane-name {
  text-align: start;
  font-size: 12px;
}

.plane-text {
  width: 65%;
  margin-left: 4px;
  border: 0;
  height: 22px;
  text-align: start;
  padding-top: 3px;
  font-size: 10.5px;
}

.auto-box {
  width: 70%;
  height: 22px;
  margin-left: 4px;
  border: 0;
  text-align: start;
  font-size: 10.5px;
}

/* 飞机 */

.plane-msg-list {
  width: 100%;
  /* margin-top: .32rem; */
  /* background-color: #f2f2f2; */
  /* overflow-y: scroll; */
}

.flight-table {
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
}

.flight-table th,
.flight-table td {
  /* border: 1px solid #ddd; */
  padding: 8px;
  text-align: left;
  white-space: pre-line;
}

/* .flight-table th {
  background-color: #f2f2f2;
}

.flight-table tr:hover {
  background-color: #f7f7f7;
}


.flight-table tr th:hover {
  background-color: #f9f9f9;
}

.flight-tbody tr td:hover {
  background-color: #fff;
} */

.price-box {
  width: 100%;
  display: flex;
  font-size: 14px;
  margin-top: 10px;
  justify-content: space-between;
}

.price-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.price-item-name {
}

.price-item-input {
  border: 0;
  height: 21px;
  padding-top: 3px;
  margin-left: 4px;
}

.hint-box {
  width: 100%;
  margin-top: 16px;
}

.hint-title {
  width: 100%;
  text-align: start;
  white-space: pre-line;
  font-size: 14px;
  font-weight: 700;
}

.hint-item {
  width: 100%;
  margin-top: 8px;
  white-space: pre-line;
  font-size: 14px;
  text-align: start;
}

.put-xing-cheng {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  position: fixed;
  z-index: 1000;
  bottom: 0;
  align-items: center;
  color: #888;
  padding: 8px 32px;
  background-color: #f7f7f7;
}

.generate-btn {
  background: #e27575;
  border: none;
  padding: 10px 25px 10px 25px;
  color: #fff;
  box-shadow: 1px 1px 5px #b6b6b6;
  border-radius: 3px;
  text-shadow: 1px 1px 1px #9e3f3f;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  margin-left: 12px;
  text-align: center;
}

input:focus {
  border: 1px solid #000;
}

.hint-text {
  margin-left: 16px;
  color: red;
  font-weight: 700;
  font-size: 14px;
}
</style>
